<template>
    <div style="fw">
        <h2>Windstation Overview</h2>

        <!-- Widget section -->
        <div v-for="(faddr, idx) in fAddrs" v-bind:key="faddr.id" :style="{display: 'flex', 'flex-direction': 'row'}">
            <div style="flex-grow: 1" />
            <windwidget-skytraxx style="flex-grow: 0" :fanetaddr="faddr" v-bind:topValue.sync="top[idx]"
                :temperature_unit="tempUnit.value" :wind_unit="windUnit.value" 
                :widgetmaxwidth="windowWidth-(editLayout ? 100 : 20)" :displaytime_h="chartTime"/>
            <div v-if="editLayout" :style="{display: 'flex', 'flex-direction': 'column'}">
                <b-button v-if="fAddrs.length > 1" :disabled="idx == 0" variant="outline-primary" class="cfgBtn1">
                    <b-icon icon="arrow-up" v-on:click="up(idx)"></b-icon>
                </b-button>
                <b-button variant="outline-primary" v-on:click="remove(faddr)" class="cfgBtn2">
                    <b-icon icon="trash"></b-icon>
                </b-button>
                <b-button v-if="fAddrs.length > 1" :disabled="idx == fAddrs.length-1" variant="outline-primary" class="cfgBtn1">
                    <b-icon icon="arrow-down" v-on:click="down(idx)"></b-icon>
                </b-button>
           </div>
            <div style="flex-grow: 1" />
        </div>

        <!-- Edit section -->
        <b-form-checkbox v-model="editLayout" name="check-button" switch  class="cfg">
            Edit
        </b-form-checkbox>
        <div v-if="editLayout" class="cfg">
            <b-container class="bv-example-row">
            <b-row class="cfg">
                <b-col>
                    <vue-bootstrap-typeahead class="" :data="windstations" @hit="selectedStation = $event"
                :serializer="s => s.name + ' (' + s.addr.str + ')'" placeholder="Type a name or address..." />
                </b-col>
            </b-row>

            <b-row class="cfg">
                <b-col align="right">Chart Duration:</b-col>
                <b-col align="left">
                    <b-form-input id="range-1" v-model="chartTime" type="range" min="1" max="10" style="width: 50%" />
                    <div class="cfg" style="display:inline;">{{ chartTime }}h</div>
                </b-col>
            </b-row>
            <b-row class="cfg">
                <b-col align="right">Wind Unit:</b-col>
                <b-col align="left">
                    <select v-model="windUnit">
                        <option v-for="wuOption in wuOptions" v-bind:key="wuOption.id" :value="wuOption">
                            {{ wuOption.text }}
                        </option>
                    </select>
                </b-col>
            </b-row>
            <b-row class="cfg">
                <b-col align="right">Temperature Unit:</b-col>
                <b-col align="left">
                    <select v-model="tempUnit">
                        <option v-for="tuOption in tuOptions" v-bind:key="tuOption.id" :value="tuOption">
                            {{ tuOption.text }}
                        </option>
                    </select>
                </b-col>
            </b-row>
            <b-row class="cfg">
                <b-col align="right">Limit Widget Width:</b-col>
                <b-col align="left">
                    <b-form-checkbox v-model="widthLimit" />
                </b-col>
            </b-row>
            </b-container>
            <div align="right">
                <small>build-201901202307</small>
            </div>
        </div>
    </div>
</template>

<script>
import {_} from 'vue-underscore';

export default {
    props: 
    {
        windstations: [],
        needLoad: Boolean,
    },

    data ()
    {
        return {
            fAddrs: [],
            top: [],

            windowWidth: Number,
            editLayout: false,
            selectedStation: JSON,
            widthLimit: true,
            chartTime: Number,

            tempUnit: {},
            tuOption: {},
            tuOptions: [
                { value: 'C', text: '℃' },
                { value: 'F', text: '℉' },
            ],
            windUnit: {},
            wuOption: {},
            wuOptions: [
                { value: 'kmph', text: 'km/h' },
                { value: 'mps', text: 'm/s' },
                { value: 'kts', text: 'kts' },
                { value: 'mph', text: 'mph' },
                { value: 'bft', text: 'bft' },
            ],
        }
    },

    methods:
    {
        remove: function(addr)
        {
            console.log('removing: ' + addr);

            /* find any fitting entry in array and remove it */
            for( var i = 0; i < this.fAddrs.length; i++)
                if(this.fAddrs[i] === addr)
                    this.fAddrs.splice(i, 1); 
        },

        onResize: function()
        {
            //note: mnobile apps seem to 
            this.windowWidth = Math.min(window.innerWidth, window.outerWidth);
            if(this.widthLimit == true && this.windowWidth > 820)
                this.windowWidth = 820;
        },

        //todo: up/down
        up: function(idx)
        {
            console.log('up' + idx);
            if(idx < 1)
                return;

            //note: does not work the smart way w/o splice
            //[this.fAddrs[idx-1], this.fAddrs[idx]] = [this.fAddrs[idx], this.fAddrs[idx-1]];
            var a = this.fAddrs[idx];
            var b = this.fAddrs[idx-1];
            this.fAddrs.splice(idx-1, 1, a);
            this.fAddrs.splice(idx, 1, b);
        },

        down: function(idx)
        {
            console.log('down' + idx);
            if(idx > this.fAddrs.length-2)
                return;

            //note: does not work the smart way w/o splice
            //[this.fAddrs[idx], this.fAddrs[idx+1]] = [this.fAddrs[idx+1], this.fAddrs[idx]];
            var a = this.fAddrs[idx];
            var b = this.fAddrs[idx+1];
            this.fAddrs.splice(idx, 1, b);
            this.fAddrs.splice(idx+1, 1, a);
        },

        doOnOrientationChange: function () 
        {
            //note: seems to be required. otherwise resize does not work
            this.onResize();
        },
    },

    computed:
    {
        
    },

    filters: 
    {

    },

    watch: 
    {
        selectedStation: _.debounce(function(station)
        {
            if(Object.keys(station).includes('addr') == false)
                return;
            
            /* do not allow for double entries */
            for( var i = 0; i < this.fAddrs.length; i++)
                if(this.fAddrs[i] === station.addr.str)
                    return;

            this.fAddrs.push(station.addr.str);
            this.selectedStation = {};  //note: remove selection so that same station can be reentered w/o retyping
        }, 250),

        fAddrs: _.debounce(function(addrs)
        {
            if(typeof addrs == 'undefined')
                return;

            //console.log('Storing fAddrs:' + addrs.toString());
            localStorage.removeItem('fAddrs');
            localStorage.setItem('fAddrs', addrs.toString());
        }, 250),

        tempUnit: function(tuObj)
        {
            if(typeof tuObj == 'undefined')
                return;

            //console.log('Storing tempUnit:' + tuObj.value);
            localStorage.removeItem('tempUnit');
            localStorage.setItem('tempUnit', tuObj.value);
        },

        windUnit: function(wuObj)
        {
            if(typeof wuObj == 'undefined')
                return;

            //console.log('Storing windUnit:' + wuObj.value);
            localStorage.removeItem('windUnit');
            localStorage.setItem('windUnit', wuObj.value);
        },

        widthLimit: function(wL)
        {
            this.onResize();

            localStorage.removeItem('widthLimit');
            localStorage.setItem('widthLimit', wL);
        },

        chartTime: function(cT)
        {
            localStorage.removeItem('chartTime');
            localStorage.setItem('chartTime', cT);
        },
    },

    mounted: function()
    {
            /* load previous config */

            /* fanet addresses */
            var addrStr = localStorage.getItem('fAddrs');
            if(addrStr != null && typeof addrStr == 'string' && addrStr.length > 0)
                this.fAddrs = addrStr.split(',');
            if(typeof this.fAddrs == 'undefined' || this.fAddrs == null || Array.isArray(this.fAddrs) == false)
                this.fAddrs = [];

            /* start edit in case of no address stored */
            if(this.fAddrs == null || this.fAddrs.length == 0)
                this.editLayout = true;

            /* temperatur unit */
            var tempUnitStr = localStorage.getItem('tempUnit');
            if(tempUnitStr != null && tempUnitStr.length)
            {
                /* find corresponding unit */
                this.tuOptions.forEach(element => 
                {
                    if(element.value == tempUnitStr)
                        this.tempUnit = element;
                });

            }
 
            /* fallback if not matching any element */
            if(Object.keys(this.tempUnit).includes('value') == false)
                this.tempUnit = this.tuOptions[0];

            /* wind unit */
            var windUnitStr = localStorage.getItem('windUnit');
            if(windUnitStr != null && windUnitStr.length)
            {
                /* find corresponding unit */
                this.wuOptions.forEach(element => 
                {
                    if(element.value == windUnitStr)
                        this.windUnit = element;
                });

            }
 
            /* fallback if not matching any element */
            if(Object.keys(this.windUnit).includes('value') == false)
                this.windUnit = this.wuOptions[0];

            /* width limit */
            var widthLimitStr = localStorage.getItem('widthLimit');
            if(typeof widthLimitStr == 'string' && widthLimitStr.length > 0)
                this.widthLimit = (widthLimitStr != 'false');

            /* chart time */
            var chartTimeStr = localStorage.getItem('chartTime');
            if(typeof chartTimeStr == 'string' && chartTimeStr.length > 0)
                this.chartTime = parseInt(chartTimeStr);
            else
                this.chartTime = 2

            /* window width */
            this.onResize();
            this.doOnOrientationChange();
            this.$nextTick(() => { window.addEventListener('resize', this.onResize); });
            this.$nextTick(() => { window.addEventListener('orientationchange', this.doOnOrientationChange); });
    },

    beforeDestroy: function() 
    { 
        window.removeEventListener('resize', this.onResize); 
    },

};
</script>

<style scoped>
.fw
{
    margin-bottom: 10px; 
    margin-left: 10px; 
    margin-right: 10px;
}
.cfgBtn1
{
    margin-top: 5px;
    margin-bottom: 5px; 
    margin-left: 10px; 
    flex-grow: 1;
}
.cfgBtn2
{
    margin-top: 5px;
    margin-bottom: 5px; 
    margin-left: 10px; 
    flex-grow: 2;
}
.cfg
{
    margin-bottom: 10px; 
    margin-left: 10px; 
    margin-right: 10px;
}

</style>